export default __webpack_public_path__ + "static/media/giftcard_thumb140.4f23edd0.jpg";